export default {
  purlData: (state) => state.purlData,
  isFetching: (state) => state.isFetching,
  landingPage: (state) => state.landingPage,
  landingPageLoaded: (state) => state.landingPageLoaded,
  favicons: (state) => state.favicons,
  auth: (state) => state.auth,
  expiration: (state) => state.auth?.expiration?.toString(),
}
